const SkillObj = {
  "Programming Languages": [
    {name:"Java",percent:90}, {name:"JavaScript",percent:90},
    {name:"TypeScript",percent:80}, {name:"C++",percent:85}
  ],
  "Backend & Web": [
    {name:"Spring Boot",percent:90}, {name:"Spring Batch",percent:85},
    {name:"Spring Data JPA",percent:85}, {name:"Spring Security",percent:85},
    {name:"REST APIs",percent:90}, {name:"Angular",percent:85},
    {name:"React",percent:85}, {name:"Node.js / Express",percent:85}
  ],
  "Databases & Data": [
    {name:"Oracle / SQL / PL/SQL",percent:90}, {name:"Apache Spark",percent:80},
    {name:"MySQL",percent:80}, {name:"MongoDB",percent:60}
  ],
  "Security & Tooling": [
    {name:"Application Security",percent:90}, {name:"MQ / TLS",percent:85},
    {name:"Git / GitHub",percent:90}, {name:"Linux / Shell",percent:85}
  ]
};
export default SkillObj;
